import i18next, { use } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enUS from './en-US.json';
import esES from './es-ES.json';
import frFR from './fr-FR.json';
import deDE from './de-DE.json';
import ptBR from './pt-BR.json';
import idID from './id-ID.json';
import ruRU from './ru-RU.json';
import trTR from './tr-TR.json';

const resources = {
  'en-US': { translation: enUS },
  'es-ES': { translation: esES },
  'fr-FR': { translation: frFR },
  'de-DE': { translation: deDE },
  'pt-BR': { translation: ptBR },
  'id-ID': { translation: idID },
  'ru-RU': { translation: ruRU },
  'tr-TR': { translation: trTR },
  // Add language code mappings for browser language detection
  en: { translation: enUS },
  es: { translation: esES },
  fr: { translation: frFR },
  de: { translation: deDE },
  pt: { translation: ptBR },
  id: { translation: idID },
  ru: { translation: ruRU },
  tr: { translation: trTR },
};

// Initialize i18next with browser language detection
use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en-US',
    debug: true, // Enable debugging to see what's happening
    interpolation: { escapeValue: false },
    detection: {
      order: ['navigator', 'htmlTag'],
      caches: [],
      lookupLocalStorage: 'i18nextLng',
      lookupCookie: 'i18next',
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,
      // Convert browser language codes to our available languages
      convertDetectedLanguage: (lng: string) => {
        console.log('Detected browser language:', lng);
        // Map browser languages to our available translations
        const languageMap: Record<string, string> = {
          es: 'es-ES',
          'es-ES': 'es-ES',
          'es-MX': 'es-ES',
          'es-AR': 'es-ES',
          fr: 'fr-FR',
          'fr-FR': 'fr-FR',
          de: 'de-DE',
          'de-DE': 'de-DE',
          pt: 'pt-BR',
          'pt-BR': 'pt-BR',
          'pt-PT': 'pt-BR',
          id: 'id-ID',
          'id-ID': 'id-ID',
          ru: 'ru-RU',
          'ru-RU': 'ru-RU',
          tr: 'tr-TR',
          'tr-TR': 'tr-TR',
          en: 'en-US',
          'en-US': 'en-US',
          'en-GB': 'en-US',
        };
        const mapped = languageMap[lng] || 'en-US';
        console.log(`Mapped ${lng} to ${mapped}`);
        return mapped;
      },
    },
  });

export const initializeLanguage = () => {
  // Language is now automatically initialized based on browser language
  // This function is kept for compatibility but no longer needed
};

export default i18next;
